import ApiAutomationsRequest from "../api-request/api-automations";

/**
 * Webhooks v2 — the automations management API (port 8096).
 * See goodday-backend/docs/code/webhooks-v2/client-api.md
 *
 * `cid` / `sid` are injected by ApiRequest._normalizePayload, so they must NOT
 * be appended to the endpoint by hand.
 */
export default class ApiAutomationsWebhooks {

    // No list() here: reading the list goes through the session,
    // gd.session.getWebhooks() - see src/core/gd-session/session-loader.ts

    // The server generates the secret; the client never sends one.
    static create(values:any) {
        return ApiAutomationsRequest.POST(this, 'webhooks/create', values)
    }

    // Partial update — only the keys sent are changed.
    // {status: 1} reactivates a suspended webhook and resets its error counter.
    static update(id:ID, values:any) {
        return ApiAutomationsRequest.POST(this, 'webhooks/update/{0}'.f(id), values)
    }

    // Soft delete. Automations pointing at this webhook keep running, they just
    // stop delivering.
    static delete(id:ID) {
        return ApiAutomationsRequest.GET(this, 'webhooks/delete/{0}'.f(id))
    }

    /*** DELIVERY HISTORY ***/

    // `cid` is kept in the query here on purpose: jQuery sends a DELETE payload
    // as a body, which the endpoint does not read. Moved verbatim from
    // ApiAutomations.getWebhookHistory / deleteWebhookLogs.
    static history() {
        return ApiAutomationsRequest.GET(this, 'webhooks/history?cid=' + gd.companyId)
    }

    static deleteHistory() {
        return ApiAutomationsRequest.DELETE(this, 'webhooks/history?cid=' + gd.companyId)
    }

}
